
export const INIT_PLAYER_START = 'INIT_PLAYER_START';
export const INIT_PLAYER_SUCCESS = 'INIT_PLAYER_SUCCESS';
export const INIT_PLAYER_ERROR = 'INIT_PLAYER_ERROR';


export const FETCH_MAP_START = 'FETCH_MAP_START';
export const FETCH_MAP_SUCCESS = 'FETCH_MAP_SUCCESS';
export const FETCH_MAP_ERROR = 'FETCH_MAP_ERROR';

export const MOVE_PLAYER_START = 'MOVE_PLAYER_START';
export const MOVE_PLAYER_SUCCESS = 'MOVE_PLAYER_SUCCESS';
export const MOVE_PLAYER_ERROR = 'MOVE_PLAYER_ERROR';